const getters = {
    navbar: state => state.app.navbar,
    footer: state => state.app.footer
}

export default getters
